import api from '../api/axios';
import { Bloque } from '../types/bloque';

export const bloqueService = {
  /** Contenido público de un bloque por su id/slug (p. ej. "home", "preguntas"). */
  get: async (id: string): Promise<Bloque> => {
    const { data } = await api.get<Bloque>(`bloques/${id}/`);
    return data;
  },

  /** Edita el contenido (solo coordinador; el backend responde 403 al resto). */
  update: async (id: string, contenido: string): Promise<Bloque> => {
    const { data } = await api.patch<Bloque>(`bloques/${id}/`, { contenido });
    return data;
  },
};
